import { connect } from "react-redux";
import { Store, asyncActions, facetsActions, searchParameterActions } from "dw_azsearchstore";
import * as redux from "redux";
import CheckboxFacet from "../components/facetbox/CheckboxFacet";
import { FacetsAction } from "dw_azsearchstore/dist/actions/facetsActions";
import { SearchParametersAction } from "dw_azsearchstore/dist/actions/searchParametersActions";

function getReturnType<RT>(expression: (...params: any[]) => RT): RT {
  return {} as RT;
}

interface OwnProps {
  facet: string;
  displayName: string;
}

const mapDispatchToProps = (
  dispatch: redux.Dispatch<FacetsAction | SearchParametersAction>,
  ownProps: OwnProps
) => {
  return {
    toggleFacet: (value: string) => {
      dispatch(
        facetsActions.toggleCheckboxFacetSelection(ownProps.facet, value)
      );
      dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
      dispatch(asyncActions.fetchSearchResultsFromFacet);
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    resetThisFilter: (facet: {[key: string]: Store.Facet})=> {
      dispatch(facetsActions.clearFacetsSelections(facet));
      dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
      dispatch(asyncActions.fetchSearchResultsFromFacet);
      window.scrollTo({top: 0, behavior: "smooth"});
    }
  };
};

function mapStateToProps(state: Store.SearchState, ownProps: OwnProps) {
  return {
    facet: state.facets.facets[ownProps.facet],
    displayName: ownProps.displayName
  };
}

export const stateProps = getReturnType(mapStateToProps);
export const dispatchProps = getReturnType(mapDispatchToProps);

export type PropsType = typeof stateProps & typeof dispatchProps;

const FacetContainer = connect(mapStateToProps, mapDispatchToProps)(
  CheckboxFacet
);

export { FacetContainer };
